import React from 'react';
import PropTypes from 'prop-types';
import {
  DetailedIconAddUser,
  Divider,
  Flex,
  Heading,
  IconCheckmarkCircle,
  Paragraph,
  TextButton,
  Upsell,
} from '@zillow/constellation';
import { WizardStep } from '@zillow/zrs-rental-applications';
import styled from 'styled-components';

const StyledDivider = styled(Divider)`
  align-self: stretch;
`;

export default function SuccessStep({ id, employees, street }) {
  const streetAddress = street ? `the property at ${street}` : 'this property';
  return (
    <WizardStep id={id} label="Success">
      <Flex display="flex" flexDirection="column" alignItems="flex-start" gap="sm">
        <IconCheckmarkCircle fontColor="green500" size="md" />
        <Heading level={4} as="h2">
          Permission setup complete
        </Heading>
        <Paragraph paddingBottom="sm">
          You’ll receive all applications for {streetAddress}. Your name will be displayed as the person viewing
          applications.
        </Paragraph>
        {employees.length < 2 ? null : (
          <>
            <StyledDivider />
            <Upsell
              heading={
                <Heading level={6} as="h2">
                  You’re the application manager
                </Heading>
              }
              body={
                <Paragraph>
                  You can allow up to 5 additional users to access applications received by your account.
                </Paragraph>
              }
              media={<DetailedIconAddUser />}
              actionButton={
                <TextButton as="a" href="/rental-manager/user-management/users">
                  Manage user permissions
                </TextButton>
              }
              closeable={false}
            />
          </>
        )}
      </Flex>
    </WizardStep>
  );
}

SuccessStep.propTypes = {
  id: PropTypes.string.isRequired,
  employees: PropTypes.array,
  street: PropTypes.string,
};
